// Mock data for construction & fit-out company website

export const companyInfo = {
  name: "Aussie Building Projects",
  tagline: "Crafting Exceptional Spaces Since 2015",
  phone: "+61 426 666 380",
  email: "aussiebuildingprojects@hotmail.com",
  location: "Melbourne, Victoria",
  yearEstablished: "2015"
};

export const heroData = {
  title: "Building Excellence in Every Detail",
  subtitle: "BPC Licensed builders partnering with Melbourne's leading construction projects. Specialists in steel fabrication and industrial fit-outs.",
  imageUrl: "https://images.unsplash.com/photo-1497366811353-6870744d04b2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBvZmZpY2UlMjBpbnRlcmlvcnxlbnwwfHx8fDE3NzExMDMyMjh8MA&ixlib=rb-4.1.0&q=85",
  stats: [
    { number: "100+", label: "Projects Completed" },
    { number: "9+", label: "Years Experience" },
    { number: "100%", label: "Client Satisfaction" }
  ]
};

export const services = [
  {
    id: 1,
    title: "Commercial Fit-Outs",
    description: "Transform your commercial space with our expert fit-out services. From restaurants to medical centres, we deliver exceptional results.",
    icon: "Building2"
  },
  {
    id: 2,
    title: "Steel Fabrication & Industrial",
    description: "Specialized in steel fabrication, precast concrete panels installation, and industrial fit-outs. Expert factory construction ensuring functionality meets safety standards and operational excellence.",
    icon: "Factory"
  },
  {
    id: 3,
    title: "Domestic Fit-Outs",
    description: "Create your dream home with our residential fit-out services. New builds, extensions, and complete renovations.",
    icon: "Home"
  }
];

export const portfolioProjects = [
  {
    id: 1,
    name: "Rococo Restaurant",
    category: "Commercial - Hospitality",
    imageUrl: "https://customer-assets.emergentagent.com/job_fitout-pros/artifacts/6y051vcm_rococo.jpg",
    description: "High-end restaurant fit-out featuring modern design and sophisticated ambiance"
  },
  {
    id: 2,
    name: "Clyde North Dental Studio",
    category: "Medical Centre",
    imageUrl: "https://customer-assets.emergentagent.com/job_fitout-pros/artifacts/padfxrv2_clyde%20north%20dental%20.jpeg",
    description: "State-of-the-art dental clinic with modern equipment and welcoming patient areas"
  },
  {
    id: 3,
    name: "La Cabra Restaurant",
    category: "Commercial - Hospitality",
    imageUrl: "https://customer-assets.emergentagent.com/job_fitout-pros/artifacts/2mmf2qqx_La-Cabra-Mordialloc_Exteriors_Credit-Brian-Doherty_05-1.jpg.webp",
    description: "Contemporary restaurant fit-out with striking exterior design and modern aesthetic"
  },
  {
    id: 4,
    name: "Commercial Fit-Out Project",
    category: "Healthcare",
    imageUrl: "https://customer-assets.emergentagent.com/job_fitout-pros/artifacts/1rnywj89_commerical%20fit%20out%20.jpg",
    description: "Comprehensive commercial facility with modern infrastructure and professional design"
  },
  {
    id: 5,
    name: "Hecho en Mexico",
    category: "Commercial - Hospitality",
    imageUrl: "https://images.unsplash.com/photo-1538333581680-29dd4752ddf2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHw0fHxyZXN0YXVyYW50JTIwaW50ZXJpb3J8ZW58MHx8fHwxNzcxMDQ1MzcxfDA&ixlib=rb-4.1.0&q=85",
    description: "Vibrant Mexican restaurant with authentic atmosphere and custom interior design"
  },
  {
    id: 6,
    name: "Luxury Residence",
    category: "Domestic Fit-Out",
    imageUrl: "https://images.unsplash.com/photo-1724582586529-62622e50c0b3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBpbnRlcmlvcnxlbnwwfHx8fDE3NzExMDMyNjV8MA&ixlib=rb-4.1.0&q=85",
    description: "Brand new luxury home with contemporary design and premium finishes"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "BPC Licensed & Insured",
    description: "Fully BPC licensed builders with comprehensive insurance coverage. Your project is in safe, qualified hands.",
    icon: "Shield"
  },
  {
    id: 2,
    title: "Steel Fabrication Experts",
    description: "Vast knowledge in steel fabrication, precast concrete panels installation, and industrial fit-outs for complex projects.",
    icon: "Hammer"
  },
  {
    id: 3,
    title: "Big Builder Partnerships",
    description: "Trusted service provider to Melbourne's leading big builders on major construction projects.",
    icon: "Award"
  },
  {
    id: 4,
    title: "Proven Track Record",
    description: "Over 100 successfully completed projects across Melbourne since 2015",
    icon: "CheckCircle2"
  },
  {
    id: 5,
    title: "On-Time Delivery",
    description: "We pride ourselves on meeting deadlines without compromising quality",
    icon: "Clock"
  },
  {
    id: 6,
    title: "Competitive Pricing",
    description: "Premium quality at fair prices with transparent quotations",
    icon: "DollarSign"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    role: "Restaurant Owner - Rococo",
    comment: "The team transformed our vision into reality. The attention to detail and professionalism was outstanding.",
    rating: 5
  },
  {
    id: 2,
    name: "Dr. James Chen",
    role: "Dental Studio Owner",
    comment: "Exceptional work on our dental clinic. They understood our specific requirements and delivered beyond expectations.",
    rating: 5
  },
  {
    id: 3,
    name: "Michael Roberts",
    role: "Homeowner",
    comment: "Our home extension project was completed on time and within budget. Highly recommend their services.",
    rating: 5
  }
];
